/**
 * Logger utility for consistent logging across the application.
 * Verbose levels are gated on the Vite DEV flag.
 */
export const logger = {
  log: (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
      console.log('[KuraPayments]', ...args);
    }
  },
  error: (...args: unknown[]): void => {
    console.error('[KuraPayments Error]', ...args);
  },
  warn: (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
      console.warn('[KuraPayments Warning]', ...args);
    }
  },
};
